import { withProps, StyledElement } from '@udecode/plate';

import { CSSProp } from 'styled-components';
import styles from 'src/shared/styles/richText';

const UL = withProps(StyledElement, {
  as: 'ul',
  styles: {
    root: styles.ul as CSSProp,
  },
});

export default UL;
